export default __webpack_public_path__ + "static/media/svgLogin.248521a3.png";